/**
 * Hides the Rebuy gift note button if the cart ONLY contains gift card products.
 */
function checkGiftNoteButtonVisibility() {

    const giftNoteButton = document.querySelector('giftnote-button[data-styles="giftnote-rebuy"]');
    const allLineItems = document.querySelectorAll('.rebuy-cart__flyout-item');
    const giftCardLineItems = document.querySelectorAll('.rebuy-cart__flyout-item.product-gift-cards');
  
    if (!giftNoteButton) {
      return;
    }
  
    const totalItemsCount = allLineItems.length;
    const giftCardItemsCount = giftCardLineItems.length;
  
    if (totalItemsCount > 0 && totalItemsCount === giftCardItemsCount) {
      giftNoteButton.style.display = 'none';
    } else {
      giftNoteButton.style.display = ''; // Resets to the default display property
    }
  }
  
  // --- Event Listeners ---
  document.addEventListener('rebuy:smartcart.ready', (event) => {
    checkGiftNoteButtonVisibility();
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
    checkGiftNoteButtonVisibility();
  });

  document.addEventListener('rebuy:smartcart.line-item-increase', (event) => {
    checkGiftNoteButtonVisibility();
  });

  document.addEventListener('rebuy:smartcart.line-item-decrease', (event) => {
    checkGiftNoteButtonVisibility();
  });

  document.addEventListener('rebuy:smartcart.line-item-removed', (event) => {
    checkGiftNoteButtonVisibility();
  });